
export enum SuffolkRecordType  {      
        Consultation = "cons",
        Monument = "mon",
        Event = "event",
        Source = "source",
        Designation = "desig",
        SuffolkBoundary= "bound"
}  

export enum SuffolkRecordSubType  {   
    Shine = "SHINE",
    ListedBuilding = "LB",
    RegisteredParksAndGardens = "RG",
    ScheduledMonument= "SAM"
}  
